import { render, staticRenderFns } from "./liveSearch.vue?vue&type=template&id=a2a53e8c&scoped=true"
import script from "./liveSearch.vue?vue&type=script&lang=js"
export * from "./liveSearch.vue?vue&type=script&lang=js"
import style0 from "./liveSearch.vue?vue&type=style&index=0&id=a2a53e8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a53e8c",
  null
  
)

export default component.exports